import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateTransform } from 'helpers/DateTransform';
import { set } from "react-hook-form";

type asignToPersonState = {
    xmlData: any,
    xmlDataHeaders: any,
    xmlDataWidths: any,
    xmlDataSorts: any,
    tableWidth: number,
    listTitle: string,
    totalAssets: number,
    assetLink: string
};

const initialState = {
    xmlData:  null,
    xmlDataHeaders: null,
    xmlDataWidths: null,
    xmlDataSorts: null,
    tableWidth: 1260,
    listTitle: "Assets on table",
    totalAssets: 0,
    assetLink:"LINK"
} as asignToPersonState;

export const asignToPersonSlice = createSlice({
    name: "asignToPersonSlice",
    initialState,
    reducers: {

        setXMLData: (state, action: PayloadAction<any>) => {
            state.xmlData = action.payload
        },

        setDataHeaders: (state, action: PayloadAction<any>) => {
            state.xmlDataHeaders = action.payload
        },

        setDataWidths: (state, action: PayloadAction<any>) => {
            state.xmlDataWidths = action.payload
        },
        setDataSorts: (state, action: PayloadAction<any>) => {
            state.xmlDataSorts = action.payload
        },
        setTableWidth: (state, action: PayloadAction<number>) => {
            state.tableWidth = action.payload
        },

        setListTitle: (state, action: PayloadAction<string>) => {
            state.listTitle = action.payload
        },

        setTotalAssets: (state, action: PayloadAction<number>) => {
            state.totalAssets = action.payload
        },

        setAssetLink: (state, action: PayloadAction<string>) => {
            state.assetLink = action.payload
        },
    },


});

export const {
    setXMLData,
    setDataHeaders,
    setDataWidths,
    setDataSorts,
    setTableWidth,
    setListTitle,
    setTotalAssets,
    setAssetLink
} = asignToPersonSlice.actions;
export default asignToPersonSlice.reducer;
